import { createApp } from 'vue';
import i18n from '@shared/plugins/i18n';
import axios from '@shared/plugins/axios';
import router from '@apps/dashboard/src/router';
import keycloak from '@apps/dashboard/src/plugins/keycloak';
import App from '@apps/dashboard/src/App.vue';
import clickOutside from '@ds/directives/clickOutside';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import 'boxicons/css/boxicons.min.css';
import '@ds/scss/styles.scss';
import { createPinia } from 'pinia';

const pinia = createPinia();

const app = createApp(App);
app.directive('click-outside', clickOutside);
app.use(pinia);
app.use(i18n);
app.use(axios);
app.use(Toast, {
	position: POSITION.BOTTOM_RIGHT,
	transition: 'Vue-Toastification__fade',
});
app.use(keycloak, {
	authenticatedCallback: () => {
		app.use(router);
		app.mount('#app');
	},
	errorCallback: () => window.location.reload(),
});
